import React, { useState, useEffect } from "react";
import { styled } from "@mui/material/styles";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import logo from "../tarteeb.png";
import logo2 from "../logo1.png";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import CardActions from "@mui/material/CardActions";
import Collapse from "@mui/material/Collapse";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import Tooltip from "@mui/material/Tooltip";
import BookingModal from "./Modal";
import Button from "@mui/material/Button";
import CircularLoading from "./CircularLoading";
import floorMap from "../Venue.png";
import skipcash from "../skipcash.png";

const ExpandMore = styled((props) => {
	const { expand, ...other } = props;
	return <IconButton {...other} />;
})(({ theme, expand }) => ({
	transform: !expand ? "rotate(0deg)" : "rotate(180deg)",
	marginLeft: "auto",
	transition: theme.transitions.create("transform", {
		duration: theme.transitions.duration.shortest,
	}),
}));


export default function RowAndColumnSpacing(props) {
	const [booths, setBooths] = useState(null);
	const [selectedBooth, setSelectedBooth] = useState(null);
	const { firstName, lastName, email, businessName, phoneNumber, termsAgreed } =
		(props.location && props.location.state) || {};
	const [openModal, setOpenModal] = useState(false);

	useEffect(() => {
		fetchBooths();
		return () => {
			console.log("changed");
		};
	}, []);

	const fetchBooths = async () => {
		// const response = await fetch("http://localhost:3001/api/booth/");
		const response = await fetch("https://tarteeb.herokuapp.com/api/booth/");

		if (response.ok) {
			const json = await response.json();

			setBooths(json);
		} else {
			const error = await response.text();
			console.log(`Error: ${error}`);
		}
	};

	const [expanded, setExpanded] = useState(-1);

	const handleExpandClick = (i) => {
		setSelectedBooth(null);
		if (i === expanded) {
			setExpanded(-1);
		} else {
			setExpanded(i);
		}
	};

	const convertNumber = (number) => {
		return new Intl.NumberFormat().format(number);
	};

	const proceed = () => {
		if (selectedBooth === null) {
			alert("Please select a booth");
			return;
		}
		console.log(firstName);
		if (firstName === undefined) {
			alert("Error!, Please complete the previous process");
			return props.history.push("/");
		}

		props.history.push({
			pathname: "/summary",
			state: {
				exhibitor: {
					firstName,
					lastName,
					email,
					businessName,
					phoneNumber,
					termsAgreed,
				},
				booth: selectedBooth,
			},
		});
	};
	return (
		<Box sx={{ minHeight: "100vh", width: "100%", backgroundColor: "#F4F4F5" }}>
			<Grid container direction="column">
				<Grid container direction="row" style={{ backgroundColor: "white" }}>
					<Grid
						item
						xs={6}
						style={{
							display: "flex",
							alignSelf: "center",
							justifyContent: "flex-end",
							paddingRight: "0.5%",
						}}
					>
						<img
							alt="tarteeb-logo"
							src={logo}
							style={{ height: 150, width: 200 }}
						/>
					</Grid>
					<Grid
						item
						xs={6}
						style={{
							display: "flex",
							alignSelf: "center",
							justifyContent: "flex-start",
							paddingRight: "0.5%",
						}}
					>
						<img
							alt="rwaiha-logo"
							src={logo2}
							style={{ height: 120, width: 160 }}
						/>
					</Grid>
				</Grid>
				<Box
					sx={{
						width: "90%",
						backgroundColor: "#F4F4F5",
						paddingLeft: "5%",
						paddingRight: "5%",
						paddingBottom: "5%",
						marginTop: "1%",
					}}
				>
					<Grid container alignItems="center" sx={{ marginBottom: "1%" }}>
						<Grid item xs={3}></Grid>
						<Grid item xs={6}>
							<Tooltip
								title="Click on the image to view the plan"
								arrow
								style={{ fontSize: 30 }}
							>
								<a
									href="https://firebasestorage.googleapis.com/v0/b/tarteeb-store.appspot.com/o/cermonial%20court-Model%20RWAIHA%203%20QF%20APPROVED%20LAYOUT%20(2).pdf?alt=media&token=51c75f0d-9ac8-493b-b729-fffe23db99c9"
									target="_blank"
									rel="noreferrer"
								>
									<img
										alt="floor-plan"
										src={floorMap}
										style={{ width: "100%", borderRadius: 15 }}
									/>
								</a>
							</Tooltip>
						</Grid>
						<Grid item xs={3}></Grid>
					</Grid>
					<Grid container justifyContent="center" sx={{ marginBottom: "1%" }}>
						<Grid
							item
							xs={12}
							style={{ display: "flex", justifyContent: "center" }}
						>
							<Typography
								style={{
									fontFamily: "Poppins",
									color: "#a67a31",
								}}
							>
								<strong>Note:</strong> You can reserve only one spot at a time
							</Typography>
						</Grid>
						<Grid
							item
							xs={12}
							style={{ display: "flex", justifyContent: "center" }}
						>
							<Typography
								style={{
									fontFamily: "Poppins",
									color: "#a67a31",
								}}
							>
								ملاحظة
								<stong>: يمكنك اختيار مساحة واحدة فقط في كل عملية حجز</stong>
							</Typography>
						</Grid>
					</Grid>

					{/* <Grid container justifyContent="center" sx={{ marginBottom: "1%" }}>
						<Button
							variant={"outlined"}
							style={{
								width: "100%",
								fontFamily: "Poppins",
								color: "white",
								borderColor: "#a67a31",
								backgroundColor: "#a67a31",
							}}
							sx={{
								width: "8%",
								marginLeft: "1%",
								marginRight: "1%",
								marginBottom: "1%",
							}}
							onClick={() => setOpenModal(true)}
						>
							Show All Bookings | عرض المشاركين في المعرض
						</Button>
					</Grid> */}

					{booths ? (
						Object.keys(booths).map((category, i) => (
							<Card key={i} sx={{ width: "100%", marginBottom: "1%" }}>
								<CardActions
									disableSpacing
									onClick={() => handleExpandClick(i)}
								>
									<CardContent>
										<Typography
											style={{
												fontFamily: "Poppins",
												color: "#a67a31",
												fontWeight: "bold",
											}}
											variant="body2"
											color="text.secondary"
										>
											{
												// console.log("sdfk", booths && booths[category])
												booths &&
													`${booths[category].fullCategory} ${category} (${
														booths[category] &&
														convertNumber(booths[category].price)
													} QAR)`
											}
										</Typography>
									</CardContent>
									<ExpandMore
										expand={i === expanded ? true : false}
										aria-expanded={i === expanded ? true : false}
										aria-label="show more"
									>
										<ExpandMoreIcon />
									</ExpandMore>
								</CardActions>
								<Collapse
									in={i === expanded ? true : false}
									timeout="auto"
									unmountOnExit
								>
									<CardContent
										sx={{
											height: "100%",
											padding: 0,
											justifyContent: "center",
											alignItems: "center",
										}}
									>
										{booths[category].data.map((booth, j) =>
											booths ? (
												<Button
													key={j}
													variant={
														selectedBooth === booth ? "contained" : "outlined"
													}
													disabled={booth.isBooked || booth.openSoon}
													style={
														selectedBooth !== booth
															? {
																	fontFamily: "Poppins",
																	color: "#a67a31",
																	borderColor: "#a67a31",
																	backgroundColor: "white",
															  }
															: {
																	fontFamily: "Poppins",
																	color: "white",
																	borderColor: "#a67a31",
																	backgroundColor: "#a67a31",
															  }
													}
													sx={{
														width: "8%",
														marginLeft: "1%",
														marginRight: "1%",
														marginBottom: "1%",
													}}
													onClick={() => setSelectedBooth(booth)}
												>
													{booths && booth.isBooked
														? <div><span style={{color: "red", fontSize: 12}}>SOLD</span> <span >{booth.name}</span></div>
														: booth.openSoon
														? "OPENING SOON"
														: booth.name}
												</Button>
											) : null
										)}
									</CardContent>
								</Collapse>
							</Card>
						))
					) : (
						<CircularLoading />
					)}
					<Grid
						container
						alignItems="center"
						sx={{ marginTop: "5%", width: "100%" }}
					>
						<Grid container justifyContent="center">
							<Card
								sx={{
									justifyContent: "center",
									alignItems: "center",
									width: "40%",
								}}
							>
								<CardContent>
									<Grid container alignItems="center">
										<Grid item xs={4}>
											<p
												style={{
													textAlign: "center",
													fontWeight: "bold",
													color: "#a67a31",
												}}
											>
												Total Amount
											</p>
										</Grid>
										<Grid item xs={4}>
											<p style={{ textAlign: "center", color: "#a67a31" }}>
												{selectedBooth && selectedBooth
													? `${convertNumber(selectedBooth.price)}  QAR`
													: 0}
											</p>
										</Grid>
										<Grid item xs={4}>
											<p style={{ textAlign: "center", color: "#a67a31" }}>
												المبلغ الإجمالي
											</p>
										</Grid>
									</Grid>

									<Button
										variant="contained"
										sx={{
											width: "100%",
											marginLeft: "1%",
											marginRight: "1%",
											marginBottom: "1%",
											borderColor: "#a67a31",
										}}
										onClick={proceed}
										style={{
											fontFamily: "Poppins",
											color: "white",
											borderColor: "#a67a31",
											backgroundColor: "#a67a31",
										}}
									>
										Proceed | المتابعة
									</Button>
								</CardContent>
							</Card>
						</Grid>
					</Grid>
				</Box>
				<Grid container justifyContent="center">
					<img alt="skipcash" src={skipcash} />
				</Grid>
			</Grid>
			<BookingModal openModal={openModal} closeModal={setOpenModal} />
		</Box>
	);
}
